import { Buffer } from "buffer";

export interface VideoContent {
  filename: string;
  output: Buffer;
  offsets: Offset[];
}

interface Offset {
  bytestart: number;
  byteend: number;
}

interface Options {
  verbose?: boolean;
}

interface IntermediateEntry {
  bytestart: number;
  byteend: number;
  text: string;
  encoding: string;
  filename: string;
}

export const findVideos = (harFileContent: string, opts?: Options): VideoContent[] => {
  const { verbose } = opts || {};

  const har = JSON.parse(harFileContent);

  const basename = (path) => {
    const parts = path.split("/");
    return parts[parts.length - 1];
  };

  const intermediateEntries = har.log.entries.map((entry) => {
    const { request } = entry,
      { queryString, method, url } = request,
      filename = basename(url.split("?")[0]),
      bytestart = queryString.find(({ name }) => name === "bytestart"),
      byteend = queryString.find(({ name }) => name === "byteend");

    // Keep only mp4 entries    
    if (!(method === "GET" && bytestart?.value && byteend?.value && filename.endsWith(".mp4"))) {
      return;
    }

    if (!entry.response.content.text) {
      console.log("no text", entry.response.content);
      return;
    }

    if (!entry.response.content.encoding) {
      console.log("no encoding");
      return;
    }

    return {
      bytestart: parseInt(bytestart.value),
      byteend: parseInt(byteend.value),
      text: entry.response.content.text,
      encoding: entry.response.content.encoding,
      filename,
    };
  }).filter(Boolean) as IntermediateEntry[];

  const entriesByFilename = intermediateEntries.reduce((acc, e) => {
    const { filename } = e;
    if (!acc[filename]) {
      acc[filename] = [];
    }
    acc[filename].push(e);
    acc[filename].sort((a, b) => a.bytestart - b.bytestart);
    return acc;
  }, {}) as Record<string, IntermediateEntry[]>;

  return Object.entries(entriesByFilename)
    .filter(([_, entries]) => entries.length && entries[0].bytestart === 0)
    .map(([filename, entries]) => {
      const outputEntries = [entries[0]].concat(entries
        .map(({ byteend }) => entries.find((e) => e.bytestart === byteend + 1))
        .filter(Boolean));
      const buffers = outputEntries.map((e) => Buffer.from(e.text, e.encoding));
      const output = Buffer.concat(buffers);
      const offsets = outputEntries.map(({ bytestart, byteend }) => ({ bytestart, byteend }));
      offsets.sort((a, b) => a.bytestart - b.bytestart);
      if (verbose) {
        console.log(filename);
        console.table(offsets);
      }
      return { filename, output, offsets };
    }).filter(Boolean);
};

export default findVideos;